<template>
  <div class="flex flex-col gap-6 text-xl font-bold border p-5 h-full">
    <a-upload-dragger class=" h-2/3" :before-upload="beforeUpload" :file-list="fileList" name="codes" accept=".rar, .zip" :action="uploadAction" @change="handleChange">
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">請點擊此處上傳更新檔案 或 拖曳更新檔案到此處</p>
    </a-upload-dragger>
  </div>
</template>
<script>
export default {
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      selectedFile: null,
      selectedUpdateTimeType: null,
      selectedUpdateTimestemp: null,
      timerShow: false,
      notes: '',
      selectedArea: '自選',
      selecteCity: [],
      selecteDistrict: [],
      selectedDeviceArr: [],
      fileList: [],
      fileListSend: [],
      uploadFileName: null,
      uploadDatetime: null,
      storeList: [],
      versionList: [],
      regionList: [],
      updateDevice: [],
      updateList: [],
      cityArr: [],
      districtArr: [],
      storesByArea: {}
    }
  },
  computed: {
    uploadAction () {
      return `${this.baseURL}${this.basePort}/update/uploadCode`
    },
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    },
    deviceList: {
      get () {
        return this.$store.state.deviceList
      },
      set () {}
    }
  },
  watch: {
    selectedUpdateTimeType: {
      handler (newValue, oldValue) {
        if (newValue === 2) {
          this.timerShow = true
        } else {
          this.timerShow = false
        }
      }
    }
  },
  async mounted () {
    // await this.GetUpdateList()
    // await this.GetDeviceList()
    // await this.GetRegionList()
    // this.CategorizeStoresByArea()
  },
  methods: {
    handleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} 上傳成功`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 上傳失敗`)
      }
    },
    beforeUpload (file) {
      this.fileList = [file]
      //   return false // 阻止默认上传行为
    },
    MqttUpload () {},
    UploadFile () {
      return new Promise((resolve, reject) => {
        // 使用FormData來包裝檔案
        const formData = new FormData()
        formData.append('codes', this.selectedFile) // 後端API需辨認 code 這個name ----uploads.single("codes")
        this.axios
          .post(this.baseURL + this.basePort + '/update/uploadCode', formData)
          .then((res) => {
            console.log(res.data)
            resolve(res.data) // 將成功的結果傳遞給 Promise
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    }
  }
}
</script>

<style lang="css" scoped>
.move {
  min-height: 35px;
}

.center-align {
  text-align: center;
  border: 1px solid black;
}

.ant-table-thead > tr > th {
  text-align: center !important;
  border: 1px solid black;
}

.ant-table .ant-table-container .ant-table-content .ant-table-header th {
  text-align: center;
}
</style>
